module.exports = __webpack_public_path__ + "static/img/icon-order-refund.c10c2f9a.png";